import { motion } from "framer-motion";
import image1 from "../assets/partnersAndSponsors/1.-Enforca-Technologies_Logo-1024x1024.png";
import image2 from "../assets/partnersAndSponsors/1app.png";
import image3 from "../assets/partnersAndSponsors/DFM LOGO WITHOUT BACKGROUND 1.png";
import image4 from "../assets/partnersAndSponsors/Frame 2 (3) 2.png";
import image5 from "../assets/partnersAndSponsors/Hacktales Logo.png";
import image6 from "../assets/partnersAndSponsors/Logo 1@4x-8 2.png";
import image7 from "../assets/partnersAndSponsors/WhatsApp Image 2025-04-21 at 11.07.33 AM.png";
import image8 from "../assets/partnersAndSponsors/cleva 2.png";
import image9 from "../assets/partnersAndSponsors/microsoft logo.png";
import image10 from "../assets/partnersAndSponsors/sUCCESS-fm-logopng.png";
import image11 from "../assets/partnersAndSponsors/stallion image logo 02 (1).png";
import image12 from "../assets/partnersAndSponsors/vaultify.png";

const sponsors = [
  { id: 1, image: image1, alt: "Enforca Technologies" },
  { id: 2, image: image2, alt: "1App" },
  { id: 3, image: image3, alt: "DFM Logo" },
  { id: 4, image: image4, alt: "Frame Logo" },
  { id: 5, image: image5, alt: "Hacktales" },
  { id: 6, image: image6, alt: "Logo" },
  { id: 7, image: image7, alt: "Sponsor Logo" },
  { id: 8, image: image8, alt: "Cleva" },
  { id: 9, image: image9, alt: "Microsoft" },
  { id: 10, image: image10, alt: "Success FM" },
  { id: 11, image: image11, alt: "Stallion" },
  { id: 12, image: image12, alt: "Vaultify" }
];

// Animation variants
const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      when: "beforeChildren"
    }
  }
};

const item = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};

const titleAnimation = {
  hidden: { y: -30, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.8,
      ease: "backOut"
    }
  }
};

export default function MeetOurPastSponsors() {
  return (
    <motion.div 
      className="flex flex-col items-center py-12 md:py-20 bg-gray"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-50px" }}
      variants={container}
    >
      <div className="w-[90%] md:w-[80%] mx-auto flex flex-col items-center gap-8 md:gap-12">
        {/* Section Title */}
        <motion.h2
          variants={titleAnimation}
          className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-gray-900"
        >
          Partners & Sponsors
        </motion.h2>

        {/* Sponsors Grid */}
        <div className="w-full">
          <motion.div 
            className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6"
            variants={container}
          >
            {sponsors.map((sponsor) => (
              <motion.div
                key={sponsor.id}
                variants={item}
                whileHover={{ 
                  scale: 1.05,
                  boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)"
                }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center justify-center p-4 md:p-6 bg-gray-50 rounded-xl shadow-sm hover:shadow-md transition-all"
              >
                <motion.img 
                  src={sponsor.image} 
                  alt={sponsor.alt} 
                  className="w-full h-auto max-h-16 object-contain"
                  loading="lazy"
                  whileHover={{ scale: 1.1 }}
                  transition={{ duration: 0.3 }}
                />
              </motion.div>
            ))}
          </motion.div>
        </div>

        {/* Optional CTA */}
        {/* <motion.div
          variants={item}
          className="mt-8 md:mt-12"
        >
          <motion.button
            whileHover={{ 
              scale: 1.05,
              backgroundColor: "#7C3AED",
              boxShadow: "0 4px 6px -1px rgba(124, 58, 237, 0.3)"
            }}
            whileTap={{ scale: 0.98 }}
            className="px-6 py-3 bg-purple-600 text-white rounded-lg font-medium transition-all"
          >
            Become a Sponsor
          </motion.button>
        </motion.div> */}
      </div>
    </motion.div>
  );
}